class MarqueeTicker extends HTMLElement {
  constructor() {
    super();
    this.track = null;
    this.animationId = null;
    this.currentPosition = 0;
    this.speed = 1;
    this.direction = 'left';
    this.pauseOnHover = false;
    this.isPaused = false;
  }

  connectedCallback() {
    this.track = this.querySelector('.marquee-ticker-track');
    if (!this.track) return;

    this.speed = parseFloat(this.dataset.speed) || 1;
    this.direction = this.dataset.direction || 'left';
    this.pauseOnHover = this.dataset.pauseOnHover === 'true';

    // CRITICAL FIX: Wait for the page to fully load so CSS/fonts apply and scrollWidth is accurate
    if (document.readyState === 'complete') {
      this.setupAnimation();
    } else {
      window.addEventListener('load', () => this.setupAnimation());
    }

    this.setupEventListeners();
  }

  setupAnimation() {
    const trackWidth = this.track.scrollWidth / 3; // Divide by 3 because we render the items 3 times
    if (trackWidth === 0) return; // Safety check
    
    this.currentPosition = 0;

    const animate = () => {
      if (!this.isPaused) {
        if (this.direction === 'left') {
          this.currentPosition -= this.speed;
          if (Math.abs(this.currentPosition) >= trackWidth) {
            this.currentPosition = 0;
          }
        } else {
          this.currentPosition += this.speed;
          if (this.currentPosition >= 0) {
            this.currentPosition = -trackWidth;
          }
        }
        this.track.style.transform = `translateX(${this.currentPosition}px)`;
      }
      this.animationId = requestAnimationFrame(animate);
    };

    if (this.direction === 'right') {
      this.currentPosition = -trackWidth;
    }

    this.animationId = requestAnimationFrame(animate);
  }

  setupEventListeners() {
    if (this.pauseOnHover) {
      this.addEventListener('mouseenter', () => {
        this.isPaused = true;
      });

      this.addEventListener('mouseleave', () => {
        this.isPaused = false;
      });
    }
  }

  disconnectedCallback() {
    if (this.animationId) {
      cancelAnimationFrame(this.animationId);
    }
  }
}

if (!customElements.get('marquee-ticker')) {
  customElements.define('marquee-ticker', MarqueeTicker);
}